export default "<!-- <section id=\"container\" >\n    <router-outlet></router-outlet>\n</section> -->"